<template>
    <div>
        <div class="mb-3">
            <label class="form-label">URL</label>
            <input class="form-control" type="text" :value="modelValue.src" @input="update('src', $event.target.value)">
        </div>
        <div class="mb-3">
            <label class="form-label">Alt</label>
            <input class="form-control" type="text" :value="modelValue.alt" @input="update('alt', $event.target.value)">
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="form-label">Width</label>
                <input class="form-control" type="text" :value="modelValue.width" @input="update('width', $event.target.value)">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Height</label>
                <input class="form-control" type="text" :value="modelValue.height" @input="update('height', $event.target.value)">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Max width</label>
                <input class="form-control" type="text" :value="modelValue.maxWidth" @input="update('maxWidth', $event.target.value)">
            </div>
        </div>
        <div class="mb-3">
            <label class="form-label">Enlace</label>
            <input class="form-control" type="text" :value="modelValue.linkUrl" @input="update('linkUrl', $event.target.value)">
        </div>
        <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" id="imgEditorNewTab"
                :checked="modelValue.openNewTab" @change="update('openNewTab', $event.target.checked)">
            <label class="form-check-label" for="imgEditorNewTab">Abrir en nueva pestaña</label>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Padding</label>
                <input class="form-control" type="text" :value="modelValue.padding" @input="update('padding', $event.target.value)">
            </div>
        </div>
        <div class="mb-3">
            <label class="form-label">Color de fondo</label>
            <div class="d-flex gap-2 align-items-center">
                <input class="form-control" type="text" :value="modelValue.backgroundColor"
                    @input="update('backgroundColor', $event.target.value)">
                <input class="form-control form-control-color" type="color"
                    :value="modelValue.backgroundColor || '#ffffff'"
                    @input="update('backgroundColor', $event.target.value)">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockImageEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
    },
};
</script>
